import { t } from "i18next";
import { Dispatch, SetStateAction, useState } from "react";
import {
  AddButton,
  ButtonsContainer,
  CancelButton,
} from "../addClientModal/addClientModal.styles";
import * as React from "react";
import { Post } from "../../../utils/fetch.util";
import { UserContext } from "../../../contexts/user.context";
import { toast } from "react-toastify";
import LoadingData from "../../loadingData/loadingData.component";

interface ToogleServerModelProps {
  setOpen: Dispatch<SetStateAction<boolean>>;
  open: boolean;
  statusServer: boolean;
  setStatusServer: Dispatch<SetStateAction<boolean>>;
}

const ToogleServerModel: React.FC<ToogleServerModelProps> = ({
  setOpen,
  open,
  statusServer,
  setStatusServer,
}) => {
  const { getValidToken } = React.useContext(UserContext);
  const [primaryPassword, setPrimaryPassword] = useState<string>("");
  const [secondaryPassword, setSecondaryPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const handletoggleServer = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    if (primaryPassword.length <= 0 && secondaryPassword.length <= 0) {
      return;
    }

    let res;
    if (statusServer) {
      res = await Post(
        `testing/Make-Server-Go-Down?password=${primaryPassword}`,
        {
          password: secondaryPassword,
        },
        getValidToken(),
      );
    } else {
      res = await Post(
        `testing/Make-Server-Go-Up?password=${primaryPassword}`,
        {
          password: secondaryPassword,
        },
        getValidToken(),
      );
    }

    if (res.error || !res.data) {
      setLoading(false);
      toast.error("something error");
      return;
    }
    statusServer ? setStatusServer(false) : setStatusServer(true);
    toast.success(res.data);
    setLoading(false);
    setOpen(false);
    setPrimaryPassword("");
    setSecondaryPassword("");
  };

  if (loading) return <LoadingData />;

  return (
    <div
      className={`toggle_server_model fixed top-0 left-0 w-full h-full bg-[#00000075] flex items-center justify-center !z-[99999] ${
        open ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div
        className="fixed top-0 left-0 w-full h-[100vh] cursor-pointer"
        onClick={() => setOpen(false)}
      ></div>
      <form
        className={`bg-white w-full max-w-[500px] p-6 relative z-[9999]`}
        onSubmit={handletoggleServer}
      >
        <h2 className="text-3xl mb-6 !text-black">
          {t(statusServer ? "make_server_go_down" : "make_server_go_up")}
        </h2>
        <div className="flex flex-col gap-2 mt-5">
          <label aria-required>{t("primary_password")}</label>
          <input
            onChange={(e) => setPrimaryPassword(e.target.value)}
            value={primaryPassword}
            name="primary_password"
            className="border"
            type="password"
            required
          />
        </div>
        <div className="flex flex-col gap-2 mt-5">
          <label aria-required>{t("secondary_password")}</label>
          <input
            onChange={(e) => setSecondaryPassword(e.target.value)}
            value={secondaryPassword}
            name="secondary_password"
            className="border"
            type="password"
            required
          />
        </div>
        <ButtonsContainer style={{ gap: "2rem" }}>
          <AddButton isLoading={loading} type="submit">
            {t("submit")}
          </AddButton>
          <CancelButton
            type="button"
            style={{ border: "2px solid black" }}
            onClick={() => setOpen(false)}
          >
            {t("cancelBtn")}
          </CancelButton>
        </ButtonsContainer>
      </form>
    </div>
  );
};

export default ToogleServerModel;
